var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 319,
    viewBox: "0 0 1920 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_119_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -56,
    y: 0,
    width: 2027,
    height: 344
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1970.9 0H-56V343.9H1970.9V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_119_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1829.11 1.3999C1815.85 1.3999 1803.13 6.66774 1793.75 16.0446L1621.84 187.955C1612.47 197.332 1599.75 202.6 1586.49 202.6H957.399H328.41C315.149 202.6 302.431 197.332 293.055 187.955L121.144 16.0446C111.767 6.66774 99.0494 1.3999 85.7885 1.3999H-16.8008V309.4H957.399H1931.7V1.3999H1829.11Z",
    fill: "white",
    stroke: "#FDDF6D",
    strokeWidth: 2.8549,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1862.74 36C1849.82 36 1837.4 41.0007 1828.08 49.9541L1647.82 223.246C1638.5 232.199 1626.08 237.2 1613.16 237.2H957.4H301.642C288.719 237.2 276.297 232.196 266.983 223.238L86.8175 49.9623C77.5029 41.0039 65.0814 36 52.1579 36H-56V343.9H957.4H1970.9V36H1862.74Z",
    fill: "#FDDF6D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 319,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFrame);
export default __webpack_public_path__ + "static/media/FooterFrame.fbe33766f2b4658566cd736906ffa3ad.svg";
export { ForwardRef as ReactComponent };